<script lang="ts">
	import { classes } from '$lib/utils';

	export let additionalClass = '';
	export let listLength: number;
</script>

<div
	class={classes(additionalClass, `${listLength >= 4 ? 'lg:grid lg:grid-cols-2' : ''} gap-4 pb-1`)}
>
	<slot />
</div>
